import { useStore } from '@/store';
import dayjs from 'dayjs';
import { useI18n as i18nHook } from 'vue-i18n';

export function useI18n () {
  const store = useStore()
  const i18n = i18nHook()

  const setLocale = (locale: 'zh-cn' | 'en') => {
    store.state.language = locale
    i18n.locale.value = locale
    dayjs.locale(locale)
    localStorage.setItem('locale', locale)
  }

  const t = (key: string, options?: any) => {
    return i18n.t(key, ['string', 'number'].includes(typeof options) ? [options] : options)
  }

  const locales = [{
    label: '简体中文',
    value: 'zh-cn'
  }, {
    label: 'English',
    value: 'en'
  }]

  return {
    locales,
    setLocale,
    t
  }
}

